// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2b3f6f649f93144c939bf4d3050acd526bae2cc9/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};